import { useSelector } from 'react-redux';
import { ProfitBasedAnalysisConfig } from '../../redux/localReports/localReports.proptype';
import { selectProfitBasedAnalysisConfig } from '../../selectors';

export const useSelectedProfitBasedAnalysisConfig = (): ProfitBasedAnalysisConfig => {
  const selectedProfitBasedAnalysisConfig = useSelector(selectProfitBasedAnalysisConfig);

  return selectedProfitBasedAnalysisConfig;
};
